import React from 'react';
import { ConfigContext } from '../../providers/ConfigContext';
import { LogoWrapper } from './styles';

export const Logo = () => {
  const config = ConfigContext.useContainer();
  const basePath =
    config.env === 'local' ? 'https://staging.port-insider.com' : '';
  return <LogoWrapper src={`${basePath}/assets/img/logo.svg`} alt="Logo" />;
};
